import * as $ from 'jquery';

export class NavigationController {
  private readonly subLevelMenus = '.js-menuArrow';
  private readonly subLevelMenusLevel2 = '.js-menuArrow2';
  private readonly hamburgerSelector = '.js-hamburger';
  private readonly goBackButtonFirstLevel = '.js-navigationBack2';
  private readonly goBackButtonSecondLevel = '.js-navigationBack3';
  private readonly mainElement = '.js-main';
  private subLinks: NodeListOf<HTMLElement> | null = document.querySelectorAll(
    this.subLevelMenus,
  );
  private subLinksLevel2: NodeListOf<HTMLElement> | null = document.querySelectorAll(
    this.subLevelMenusLevel2,
  );
  private hamburgerNavigation: HTMLElement | null = document.querySelector(this.hamburgerSelector);
  private goBackButtonListener: NodeListOf<HTMLElement> | null = document.querySelectorAll(
    this.goBackButtonFirstLevel,
  );
  private goBackButtonListenerSecondLevel: NodeListOf<HTMLElement> | null = document.querySelectorAll(
    this.goBackButtonSecondLevel,
  );
  private mainListener: HTMLElement | null = document.querySelector(this.mainElement);

  constructor() {
    this.subLinks?.forEach(el => el.addEventListener('click', this.openMobileSubMenu));
    this.subLinksLevel2?.forEach(el => el.addEventListener('click', this.openMobileSubMenuLevel2));
    this.hamburgerNavigation?.addEventListener('click', this.toggleMenu);
    this.mainListener?.addEventListener('click', this.removeMobileMenu);
    this.goBackButtonListener?.forEach(el => el.addEventListener('click', this.goBackLevelOne));
    this.goBackButtonListenerSecondLevel?.forEach(el => el.addEventListener('click', this.goBackLevelTwo));
  }

  openMobileSubMenu(event) {
    const parentNode = event.target.parentNode;
    const firstLevel = event.target.parentNode.parentNode;
    parentNode.classList.add('nav__listItemArrow--open');
    firstLevel.classList.add('nav__list--hidden');
  }

  openMobileSubMenuLevel2(event) {
    event.target.parentNode.classList.add('nav__listItem--open');
    event.target.parentNode.parentNode.classList.add('nav__list--hidden');
  }

  removeMobileMenu() {
    const hamburger = document.getElementsByClassName('js-navigationContainer')[0];
    const navigationtoggle = document.getElementsByClassName('js-navigation')[0];
    if (hamburger.classList.contains('mobileNavigation__container--open')) {
      hamburger.classList.remove('mobileNavigation__container--open');
    }
    if (navigationtoggle.classList.contains('nav--open')) {
      navigationtoggle.classList.remove('nav--open');
    }
  }

  toggleMenu() {
    const navigationtoggle = document.getElementsByClassName('js-navigation')[0];
    const hamburger = document.getElementsByClassName('js-navigationContainer')[0];
    hamburger.classList.toggle('mobileNavigation__container--open');
    navigationtoggle.classList.toggle('nav--open');
  }

  goBackLevelOne(event) {
    event.target.closest('.nav__listItemArrow--open').classList.remove('nav__listItemArrow--open');
    event.target.closest('.nav__list--hidden').classList.remove('nav__list--hidden');
  }

  goBackLevelTwo(event) {
    event.target.closest('.nav__listItem--open').classList.remove('nav__listItem--open');
    event.target.closest('.nav__list--hidden').classList.remove('nav__list--hidden');
  }
}
